import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import authService from './authService';

const moduleApi = axios.create({
  baseURL: `${API_BASE_URL}/modules`,
  headers: { 'Content-Type': 'application/json' },
});

moduleApi.interceptors.request.use((config) => {
  const token = authService.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const moduleService = {
  getAll: () => moduleApi.get(''),
  getModulesWithSubModules: () => moduleApi.get('/tree'),
  getAccessibleModules: () => moduleApi.get('/accessible'),
  getMyPermissions: () =>
    axios.get(`${API_BASE_URL}/users/me/module-permissions`, {
      headers: {
        Authorization: `Bearer ${authService.getToken() || ''}`,
      },
    }),
  getUserPermissions: (userId) =>
    axios.get(`${API_BASE_URL}/users/${userId}/module-permissions`, {
      headers: {
        Authorization: `Bearer ${authService.getToken() || ''}`,
      },
    }),
  updateUserPermissions: (userId, permissions) =>
    axios.put(`${API_BASE_URL}/users/${userId}/module-permissions`, permissions, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authService.getToken() || ''}`,
      },
    }),
};

export default moduleService;


